import { render, staticRenderFns } from "./ErrorAnimated.vue?vue&type=template&id=44fec6c8"
import script from "./ErrorAnimated.vue?vue&type=script&lang=js"
export * from "./ErrorAnimated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports